export { TANK_TYPES, TANK_TYPES_NAME_VALUE } from './tankTypes';

export const COMMONS = Object.freeze({
  ADD: 'ADD',
  PDF: 'pdf',
  HUB: 'hub',
  EDIT: 'EDIT',
  PREV: 'prev',
  NONE: 'None',
  TEXT: 'text',
  IMAGE: 'image',
  TRUCK: 'truck',
  GROUP: 'group',
  ERROR: 'error',
  FILTER: 'filter',
  DRIVER: 'driver',
  CREATE: 'create',
  DELETE: 'delete',
  STATUS: 'status',
  SUCCESS: 'success',
  TRAILER: 'trailer',
  REGULAR: 'REGULAR',
  SKIPPED: 'skipped',
  DELIVERED: 'delivered',
  WARNING: 'warning',
  CUSTOMER: 'customer',
  PRIORITY: 'priority',
  END_DATE: 'end_date',
  FOR_FORM: 'FOR_FORM',
  SUBTRACT: 'SUBTRACT',
  DOCUMENT: 'document',
  NOT_AVAILABLE: 'N/A',
  ICON_ONLY: 'ICON_ONLY',
  FOR_TABLE: 'FOR_TABLE',
  START_DATE: 'start_date',
  NORMAL_PRIORITY: 'normal',
  URGENT_PRIORITY: 'urgent',
  DELETE_ITEM: 'DELETE_ITEM',
  COMMON_CARRIER: 'common_carrier',
});

export const INCH = 'inch';

export const NOT_AVAILABLE = 'N/A';
export const NA = 'NA';

export const EDITABLE_ICONS = Object.freeze({
  UNDO_ICON: 'undo',
  SAVE_ICON: 'save',
  EDIT_ICON: 'pencil',
  CANCEL_ICON: 'times',
});

export const SCHEDULE = Object.freeze({
  EARLIEST: 'earliest',
  LATEST: 'latest',
  WORK: 'work',
  BREAK: 'break',
});

export const TRANSFER_TYPE = Object.freeze({
  ALL_TO_RIGHT: 'ALL_TO_RIGHT',
  ALL_TO_LEFT: 'ALL_TO_LEFT',
  TO_RIGHT: 'TO_RIGHT',
  TO_LEFT: 'TO_LEFT',
});

export const DATE_FORMAT = Object.freeze({
  T: 'T',
  DD: 'DD',
  HH_mm: 'HH:mm',
  MMM_DD: 'MMM dd',
  D_LLL_H_MM_A: 'd LLL, h:mm a',
  HH_MM_A: 'hh:mm a',
  ccc_LLL_d: 'ccc, LLL d',
  YYYY_MM_DD: 'yyyy-MM-dd',
  MM_DD_YYYY: 'MM/dd/yyyy',
  LLL_d_yyyy: 'LLL d, yyyy',
  MMM_DD_YYYY: 'MMM dd, yyyy',
  MMM_DD_HH_MM: 'MMM dd, HH:mm',
  LLL_dd_HH_mm: 'LLL dd, HH:mm',
  ccc_LLL_d_HH_mm: 'ccc LLL d, HH:mm',
  MM_dd_yyyy_HH_mm: 'MM/dd/yyyy HH:mm',
  MM_dd_yyyy_HH_mm_a: 'MM/dd/yyyy hh:mm a',
  MM_dd_yyyy_00_01: 'MM/dd/yyyy 00:01',
  YYYY_MM_DD_HH_MM: 'yyyy-MM-dd HH:mm',
  MMM_dd_yyyy_HH_MM: 'MMM dd yyyy, HH:mm',
  MMM_DD_YYY_H_MMM_A: 'MMM dd yyyy, h:mm a',
  YYYY_MM_DD_HH_MM_A: 'yyyy-MM-dd hh:mm a',
  YYYY_MM_DD_HH_MM_SS_ZZZ: 'yyyy-MM-dd HH:mm:ss ZZZ', // 2025-02-02 03:00:00 -1100
  YYYY_M_D_H_MM_A: 'yyyy-M-d h:mm a',
});

export const DATE_TIME_DURATION_KEYS = Object.freeze({
  DAYS: 'days',
  HOURS: 'hours',
  YEARS: 'years',
  WEEKS: 'weeks',
  MONTHS: 'months',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
  QUARTERS: 'quarters',
  MILLISECONDS: 'milliseconds',
});

export const PAST_DAYS_TO_SHOW_LOD = 7;

export {
  MAX_NUMBER_LIMIT_REGEX,
  RATE_LIMIT_FOR_LOADING_ORDER,
  RATE_LIMIT_FOR_DELIVERY_ORDER,
  RATE_LIMIT_FOR_DELIVERY_ORDER_BILLING_RATE,
  RATE_LIMIT_FOR_EXTRACTION_ORDER,
} from './regex';

export const RATE_DECIMAL_PLACES = 4;
export const AMOUNT_DECIMAL_PLACES = 2;
export const INVOICE_RATE_DECIMAL_PLACES = 5;

// Old version keys
// dashboardGrid_17062020
export const DASHBOARD_LAYOUT_CONFIG_VERSION_KEY = 'dashboardGrid_25102020';
export const DASHBOARD_CUSTOMER_PORTAL_LAYOUT_KEY = 'dashboard_grid_customer_portal_25102020';

export const API_LIMIT = 10;

export const LINE_ITEMS_SOURCES = {
  manual: 'Manual',
  code_scan: 'Code Scan',
  lcr_meter: 'LCR Meter',
  box: 'Box',
};

export enum HTTP_STATUS_CODE {
  FAILED = 0,
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  ENTITY_NOT_FOUND = 422,
  INTERNAL_SERVER_ERROR = 500,
}

export enum ORDER_TYPE {
  DELIVERY = 'delivery',
  EXTRACTION = 'extraction',
  LOADING = 'loading',
  TRANSFER = 'transfer',
}

export const PASSWORD = 'BLACKPANDA';

export const LINE_ITEMS_UPDATING_WARNING =
  'Line items are updating please wait for it to complete to perform any actions on this order.';
